import { UUID } from 'types/shared/UUID';
import { IPCDashboardTaskData } from 'types/pcDashboard/IDashboardTasks';
import { eUSAState } from '../../ui-toolkit/enums/states';
import { eTransactionCategory } from '../../ui-toolkit/enums/eTransactionType';
import { eInternalOrderStatus } from '../../ui-toolkit/enums/eInternalOrderStatus';
import { BaseAPI } from 'API/BaseApi';
import { eAPITags } from 'API/eAPITags';
import { IPageData, convertFromIQueryResponseToIPageData } from 'types/rest/IPageData';
import { IQueryResponse } from 'types/rest/IQueryResponse';

export interface ITasksParams {
  teammates?: UUID[] | null;
  internalContacts?: UUID[] | null;
  clientCompanies?: UUID[] | null;
  internalContact?: UUID[] | null;
  closingDateStart?: string | null;
  closingDateEnd?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  page?: number;
  size: number | null;
  sort?: 'asc' | 'desc' | null;
  sortProperty?: string | null;
  transactionCategories?: eTransactionCategory[] | null;
  orderStatuses?: eInternalOrderStatus[] | null;
  states?: eUSAState[] | null;
}

export const SearchTasksByFilterParametersAPI = BaseAPI.injectEndpoints({
  endpoints: (build) => ({
    listPagedTasksByFilterParams: build.query<IPageData<IPCDashboardTaskData>, ITasksParams>({
      query: (body) => ({
        url: '/timber/api/internal/orders/tasks/search',
        method: 'POST',
        body,
      }),
      transformResponse: (baseReturnValue: IQueryResponse<IPCDashboardTaskData>) => {
        return convertFromIQueryResponseToIPageData(baseReturnValue, (data) => data);
      },
      providesTags: (result) => [
        ...(result?.content ?? []).map(({ taskId }) => ({ type: eAPITags.TasksByFilterParams, id: taskId })),
        { type: eAPITags.TasksByFilterParams, id: 'LIST' },
      ],
    }),
  }),
  overrideExisting: false,
});

export const { useListPagedTasksByFilterParamsQuery } = SearchTasksByFilterParametersAPI;
